import {
  Card,
  CardActions,
  CardContent,
  Grid,
  IconButton,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import PropTypes from "prop-types";
import EditIcon from "@mui/icons-material/Edit";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import {Button, FormControl, InputLabel, MenuItem, Select, TextField} from "@material-ui/core";
import { db } from "../../firebase";
import {useAuth} from "../../contexts/AuthContext";
import {useHistory} from "react-router";

const style = {
  position: "absolute",
  top: "45%",
  left: "50%",
  width: "35.5vh",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

function Profile(props) {
  const { logout } = useAuth();
  const history = useHistory();
  const { user, uid, currentUser } = props;

  const [isEditing, setEditing] = useState(false);
  const [region, setRegion] = useState(user.region);

  const handleChange = (event) => {
    setRegion(event.target.value);
  };

  const handleEdit = () => {
    setEditing(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData(e.currentTarget);
    db.collection("users")
      .doc(uid)
      .set(
        {
          firstname: data.get("firstname"),
          lastname: data.get("lastname"),
          middlename: data.get("thirdName"),
          email: data.get("email"),
          age: data.get("age"),
          region: region,
        },
        { merge: true }
      )
      .then(() => {
        setEditing(false);
      });
  };
  const logoutHandler = async () => {
    try {
      await logout();
      history.push("/login");
    } catch (e) {
      console.log(e);
    }
  };

  const handleClose = () => setEditing(false);

  const renderForm = (u) => {
    let { firstname, lastname, middlename, age, email } = u;

    return (
      <Box
        onSubmit={handleSubmit}
        component="form"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" component="h2">
          Редактирование
        </Typography>

        <TextField
          style={{ marginTop: 10 }}
          defaultValue={lastname}
          size="small"
          name="lastname"
          label="Фамилия"
          variant="outlined"
          required
        />

        <TextField
          style={{ marginTop: 10 }}
          defaultValue={firstname}
          size="small"
          name="firstname"
          label="Имя"
          variant="outlined"
          required
        />

        <TextField
          style={{ marginTop: 10 }}
          defaultValue={middlename}
          size="small"
          name="thirdName"
          label="Отчество"
          variant="outlined"
        />
        <TextField
          style={{ marginTop: 10 }}
          size="small"
          required
          defaultValue={age}
          name="age"
          label="Возраст"
          type="number"
          variant="outlined"
        />
        <TextField
          style={{ marginTop: 10 }}
          defaultValue={email}
          required
          type="email"
          size="small"
          name="email"
          label="Почта"
          variant="outlined"
        />

        <FormControl variant="outlined" size="small" style={{ width: 224, marginTop: 10 }}>
          <InputLabel>Округ</InputLabel>
          <Select required value={region} label="Регион" onChange={handleChange}>
            <MenuItem value="Центральный">Центральный</MenuItem>
            <MenuItem value="Северный">Северный</MenuItem>
            <MenuItem value="Северо-Восточный">Северо-Восточный</MenuItem>
            <MenuItem value="Восточный">Восточный</MenuItem>
            <MenuItem value="Юго-Восточный">Юго-Восточный</MenuItem>
            <MenuItem value="Южный">Южный</MenuItem>
            <MenuItem value="Юго-Западный">Юго-Западный</MenuItem>
            <MenuItem value="Западный">Западный</MenuItem>
            <MenuItem value="Северо-Западный">Северо-Западный</MenuItem>
            <MenuItem value="Зеленоградский">Зеленоградский</MenuItem>
            <MenuItem value="Троицкий и Новомосковский">
              Троицкий и Новомосковский
            </MenuItem>
          </Select>
        </FormControl>

        <Button
          style={{ marginTop: 15 }}
          type="submit"
          variant="contained"
          size="small"
        >
          Подтвердить
        </Button>
      </Box>
    );
  };

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Typography fontFamily="Mossport" sx={{ fontSize: 25 }} color="text.secondary" gutterBottom>
          ЛИЧНЫЙ КАБИНЕТ
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography color="red" component="div">
              Фамилия
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography component="div">{user.lastname}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography color="red" component="div">
              Имя
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography component="div">{user.firstname}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography color="red" component="div">
              Отчество
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography component="div">{user.middlename}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography color="red" component="div">
              Возраст
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography component="div">{user.age}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography color="red" component="div">
              Номер телефона
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography component="div">{user.phoneNumber}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography color="red" component="div">
              Почта
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography component="div">{user.email}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography color="red" component="div">
              Округ
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography component="div">{user.region}</Typography>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions>
        {(uid === currentUser.uid)  ? (
          <IconButton onClick={handleEdit} aria-label="share">
            <EditIcon />
          </IconButton>
        ) : null}

        <div style={{width: "100%"}}>
          <Button onClick={logoutHandler} style={{float: "right"}} variant="outlined">
            Выйти
          </Button>
        </div>

      </CardActions>

      <Modal open={isEditing} onClose={handleClose}>
        <Box sx={style}>{renderForm(user)}</Box>
      </Modal>
    </Card>
  );
}

Profile.propTypes = {
  user: PropTypes.any,
  uid: PropTypes.any,
  currentUser: PropTypes.any,
};

export default Profile;
